import React from "react";
import "../styles/Shareholders.css";
import ShareholderImg from "../assets/photos/shareholders.png"

function Shareholders() {
    return (
        <div className="shareholders-page">

            {/* HERO SECTION */}
            <section className="shareholders-hero">
                <div className="hero-content">
                    <h1>Shareholders</h1>
                </div>
            </section>

            {/* NOTICE SECTION */}
            <section className="shareholders-notice">
                <div className="container">
                    <div className="notice-content">

                        {/* LEFT SIDE - 60% */}
                        <div className="notice-text">
                            <h2>Notice to Members</h2>

                            <ul>
                                <li>
                                    Members may submit their Latest KYC in bank's nearest branch.
                                </li>

                                <li>
                                    Those members not having minimum shareholding amount of Rs.1000/-,
                                    they may take additional share amount to fulfill the minimum shareholding.
                                </li>

                                <li>
                                    Legal heirs may raise death claim of their deceased member/s.
                                </li>
                            </ul>

                        </div>
                        {/* RIGHT SIDE - 40% */}
                        <div className="notice-image">
                            <img
                                src={ShareholderImg}
                                alt="Business Meeting"
                            />
                        </div>
                    </div>

                </div>
            </section>

        </div>
    );
}

export default Shareholders;